export const SET_SELECTED_CLASSIC_PAY_STUDENTS = "SET_SELECTED_CLASSIC_PAY_STUDENTS";
export const SET_SELECTED_FLASH_PAY_STUDENTS = "SET_SELECTED_FLASH_PAY_STUDENTS";
export const SET_SELECTED_AUTOMATIC_PAYMENT_STUDENT = "SET_SELECTED_AUTOMATIC_PAYMENT_STUDENT";
export const SET_SELECTED_COST_BEARER_CLASSIC_PAY_STUDENTS = "SET_SELECTED_COST_BEARER_CLASSIC_PAY_STUDENTS";
export const SET_SELECTED_COST_BEARER_SINGLE_STUDENT = "SET_SELECTED_COST_BEARER_SINGLE_STUDENT";
